import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(state: RootState['smartLinkArticlesHelper'] = { articles: [] }, action: Action) {
  switch (action.type) {
    case 'UPDATE_SMART_LINK_ARTICLE_HELPER': {
      return action.payload
    }
    default:
      return state
  }
}
